const HEADINGS_DROPDOWN_BUTTON_DATA_HOOK = "headingsDropdownButton";
export {
  HEADINGS_DROPDOWN_BUTTON_DATA_HOOK
};
//# sourceMappingURL=data-hooks.js.map
